import React, { useEffect } from "react";
import CalendarSeason from "../../calendar/CalendarSeason";
import ShadowBox from "../container/ShadowBox";
import PaymentSummary from "../../dataitem/PaymentSummary";

const PersonEchelon = ({ seasons, mt = 6 }) => {

    const [seasonList, setSeasonList] = React.useState([]);
    const [selectedSeason, setSelectedSeason] = React.useState(null);
    const [selectedEchelonPayments, setSelectedEchelonPayments] = React.useState(null);

    useEffect(() => {
        const sl = Boolean(seasons) ? Object.keys(seasons).map((key) => {
            return {
                echelonMemberId: key,
                echelonName: seasons[key].echelonName,
                seasonAcronym: seasons[key].seasonAcronym,
                startDate: seasons[key].startDate,
            }
        }).sort((a, b) => a.startDate < b.startDate ? -1 : 1 ) : [];
        setSeasonList(sl);

        const ss = sl.length - 1;
        setSelectedSeason(ss);

        const selectedEchelonMemberId = sl[ss].echelonMemberId;
        setSelectedEchelonPayments({
            initialFee: seasons[selectedEchelonMemberId].initialFee,
            monthlyFee: seasons[selectedEchelonMemberId].monthlyFee,
            otherPayments: seasons[selectedEchelonMemberId].otherPayments,
        });
    }, [seasons]);

    if (selectedSeason < 0 || selectedSeason >= seasonList.length) return null;

    const onPrevSeasonClick = () => {
        const season = Math.max(0, selectedSeason - 1);
        setSelectedSeason(season);
        const selectedEchelonMemberId = seasonList[season].echelonMemberId;
        setSelectedEchelonPayments({
            initialFee: seasons[selectedEchelonMemberId].initialFee,
            monthlyFee: seasons[selectedEchelonMemberId].monthlyFee,
            otherPayments: seasons[selectedEchelonMemberId].otherPayments,
        });
    }

    const onNextSeasonClick = () => {
        const season = Math.min(seasonList.length - 1, selectedSeason + 1);
        setSelectedSeason(season);
        const selectedEchelonMemberId = seasonList[season].echelonMemberId;
        setSelectedEchelonPayments({
            initialFee: seasons[selectedEchelonMemberId].initialFee,
            monthlyFee: seasons[selectedEchelonMemberId].monthlyFee,
            otherPayments: seasons[selectedEchelonMemberId].otherPayments,
        });
    }

    const initialPayments = Object.keys(seasons).map((key) => seasons[key].initialFee);
    const monthlyPayments = Object.keys(seasons).map((key) => {
        return Object.keys(seasons[key].monthlyFee).map(mt => seasons[key].monthlyFee[mt])
    }).reduce((acc, val) => acc.concat(val), []);
    const otherPayments = Object.keys(seasons).map((key) => seasons[key].otherPayments).reduce((acc, val) => acc.concat(val), []);
    const summaryInput = initialPayments.concat(monthlyPayments).concat(otherPayments);

    return (
        <ShadowBox title="Mensalidades" titleVariant="h3" mt={mt}>
            <PaymentSummary payments={summaryInput} paymentType="ECHELON" />
            <CalendarSeason
                selectedSeason={seasonList[selectedSeason]}
                onPrevSeasonClick={onPrevSeasonClick}
                onNextSeasonClick={onNextSeasonClick}
                disablePrev={selectedSeason === 0}
                disableNext={selectedSeason === seasonList.length - 1}
                payments={selectedEchelonPayments}
                mt={3} />
        </ShadowBox>
    )
}

export default PersonEchelon;
